import { NAME, EMAIL, ROLE, LAST_ACTIVE } from '../../constants/userHeaders';

/**
 * @function compare - to compare two values {a} and {b} and return a numeric result based on how they relate to each other
 * @param {String} sortedByValue - the value to be compared {a} and {b} are determined
 * @param {Boolean} shouldReverse - decides if sort by ascending or descending order
 * possible values of {a} and {b} determined by @param {sortedByValue}:
 * @constant {String} NAME - {first_name + last_name}
 * @constant {String} EMAIL - {email}
 * @constant {String} ROLE - {role}
 * @constant {String} LAST_ACTIVE - {last_active_session}
 * @constant {undefined} - value_a/b of {last_active_session} will be undefined if it is a newly created User
 * checking undefined value will ensure {last_active_session} is sorted correctly with the new User
 *
 */
const compare = (value_a, value_b, shouldReverse) => {
  if (shouldReverse) {
    if (value_a > value_b || value_a === undefined) {
      return -1;
    } else if (value_a < value_b || value_b === undefined) {
      return 1;
    } else {
      return 0;
    }
  } else {
    if (value_a > value_b || value_a === undefined) {
      return 1;
    } else if (value_a < value_b || value_b === undefined) {
      return -1;
    } else {
      return 0;
    }
  }
};
export const handleSortingPSAPUsers = (
  currentPSAPUsers = [],
  sortedByValue,
  shouldReverse,
) => {
  return currentPSAPUsers.sort((a, b) => {
    if (sortedByValue === NAME) {
      const name_a = a.first_name + a.last_name;
      const name_b = b.first_name + b.last_name;
      return compare(name_a.toLowerCase(), name_b.toLowerCase(), shouldReverse);
    } else if (sortedByValue === EMAIL) {
      return compare(
        a.email.toLowerCase(),
        b.email.toLowerCase(),
        shouldReverse,
      );
    } else if (sortedByValue === ROLE) {
      return compare(a.role.toLowerCase(), b.role.toLowerCase(), shouldReverse);
    } else if (sortedByValue === LAST_ACTIVE) {
      return compare(
        a.last_active_session,
        b.last_active_session,
        shouldReverse,
      );
    } else {
      // default sort by date_joined
      return compare(a.date_joined, b.date_joined, shouldReverse);
    }
  });
};
